import { z } from "zod";
import { AltAssetId, DateSchema, ExternalAccountId, FartherAccountId, } from "../../Types";
import { GoalBasedFinancialPlanAccountIdSchema, GoalBasedFinancialPlanIdSchema, } from "../ids";
export const AccountDataTypeSchema = z.enum([
    "marketValue",
    "returns",
    "volatility",
]);
export const AccountDataRecordSchema = z.record(AccountDataTypeSchema, z.string());
export const AccountDataResponseSchema = z.object({
    goalBasedAccountId: GoalBasedFinancialPlanAccountIdSchema,
    data: AccountDataRecordSchema,
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});
const PlatformAccountTypes = [
    "FartherManagedAccount",
    "ManuallyTrackedAccount",
    "ExternalAccount",
];
export const PlatformAccountType = z.enum(PlatformAccountTypes);
export const GoalBasedFinancialPlanAccountResponseSchema = z.object({
    goalBasedAccountId: GoalBasedFinancialPlanAccountIdSchema,
    goalBasedFinancialPlanId: GoalBasedFinancialPlanIdSchema,
    accountType: PlatformAccountType,
    accountId: z.union([FartherAccountId, AltAssetId, ExternalAccountId]),
    accountData: AccountDataResponseSchema.nullish(),
    createdAt: DateSchema,
    updatedAt: DateSchema,
});
export const GoalBasedFinancialPlanAccountPostRequestSchema = z.discriminatedUnion("accountType", [
    z.object({
        accountType: z.literal("FartherManagedAccount"),
        accountId: FartherAccountId,
    }),
    z.object({
        accountType: z.literal("ManuallyTrackedAccount"),
        accountId: AltAssetId,
        accountData: AccountDataRecordSchema,
    }),
    z.object({
        accountType: z.literal("ExternalAccount"),
        accountId: ExternalAccountId,
        accountData: AccountDataRecordSchema,
    }),
]);
export const GoalBasedFinancialPlanAccountsPostAllRequestSchema = z.object({
    accounts: z.array(GoalBasedFinancialPlanAccountPostRequestSchema),
});
export const GoalBasedFinancialPlanAccountsPostAllResponseSchema = z.object({
    accounts: z.array(GoalBasedFinancialPlanAccountResponseSchema),
});
export const GoalBasedFinancialPlanAccountPatchRequest = z.discriminatedUnion("accountType", [
    z.object({
        accountType: z.literal("ManuallyTrackedAccount"),
        accountId: AltAssetId,
        accountData: AccountDataRecordSchema,
    }),
    z.object({
        accountType: z.literal("ExternalAccount"),
        accountId: ExternalAccountId,
        accountData: AccountDataRecordSchema,
    }),
]);
export const GoalBasedFinancialPlanAccountDeleteResponseSchema = z.object({
    message: z.string(),
});
//# sourceMappingURL=types.js.map